import {Collapse, List, ListItem, ListItemText} from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import React from 'react';
import MenuStateProvider from './MenuStateProvider';
import './NestedList.sass';

type NestedListProps = {
  mainListItemTitle: string;
  children: JSX.Element;
  isExpanded: boolean;
  onExpand?: () => void;
  onCollapse?: () => void;
};

const NestedList = (props: NestedListProps) => {
  return (
    <MenuStateProvider>
      {({open, close, anchor}) => (
        <>
          <ListItem
            button
            onClick={e => {
              if (Boolean(anchor)) {
                close();
                if (props.onCollapse) {
                  props.onCollapse();
                }
              } else {
                open(e.currentTarget);

                if (props.onExpand) {
                  props.onExpand();
                }
              }
            }}
          >
            <ListItemText primary={props.mainListItemTitle} />
            {Boolean(anchor) || props.isExpanded ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={Boolean(anchor) || props.isExpanded} timeout="auto" unmountOnExit>
            <List className="nested-list__sub-list" component="div" disablePadding>
              {props.children}
            </List>
          </Collapse>
        </>
      )}
    </MenuStateProvider>
  );
};

export default NestedList;
